<template>
  <div id="app" v-bind:style="{'font-size': textSize}"
    @mousemove.prevent="mouseMove">
    <b-container  id="app-banner">
      <div class="loading" v-show="$store.getters.getLoading">{{$t('message.Load_txt')}}</div>
      <router-view :init="init"/>
    </b-container>
  </div>
</template>

<script>
import i18n from "@/i18n/lang";
import * as tools from './tool'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  components: {
    i18n
  },
  data () {
    return {
      userInfos: {
		            iD: '',
		            name: '匿名者',
		            type: '',
		            status: '4',
		            loginTime: new Date(),
		            isInit: false
	            },
      idleTime: 0,
      timer: null,
      init: false
    }
  },
  computed: {
    ...mapGetters('system', {
      sysId: 'getSysId'
    }),
    ...mapGetters([
      'getLoading',
      'getUser'
    ]),
    setting () {
      return this.$store.getters.getSetting
    },
    textSize () {
      return (this.$store.getters.getSize == 2? '1.5rem': '1rem')
    },
  },
  methods: {
    mouseMove(event) {
      this.idleTime = 0;
    },
    fetchEventsList: function() {
      if (this.$store.state.user.isInit) {
        var interval = 60;
        if (this.setting != null) {
          var num = parseInt(this.setting.idleInterval[0].codeName)
          if (num > 0) {
            interval = num;
          }
        }

        this.idleTime++;
        if (this.idleTime > interval) {
          alert(this.setting.idleMessage[0].codeName);

          var user = {
            id1: this.$store.state.user.id,
            id2: '',
            id3: '',
            isLogin: false,
            sysId: this.sysId
          }
          var vm = this
          this.$http.put('./WebApi/Common/Authorized', user)
            .then((response) => {
              if (response.data != null) {
                //console.log('logout' + user.id);
              }
            })
            .catch(function (error) {
              tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
            })
            vm.$store.dispatch('resetLogin');
            vm.idleTime = 0;
            // vm.$router.push({ path: '/login' });
        }
      }
    }
  },
  mounted () {
    this.timer = setInterval(this.fetchEventsList, 60000)
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style>
@import './assets/styles/ncut_front.css';


#app {
  font-family: -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  margin:0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
#app-banner{max-width: 1800px;}
</style>
